
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'frame'
import { ModuleRoutes as FbtSubmissionsRoutes } from 'features/fbt-submissions'
import { ModuleRoutes as FbtSummaryRoutes } from 'features/fbt-summary'

import useFbtNavigation from './navigation-config'
import { useEnabledFeatureToggleList, useSelectedPremiumFleets } from 'features/settings'
import { Page404 } from 'frame/components'

const FBTRoutes = () => {
  const navigation = useFbtNavigation()
  const featureToggleList = useEnabledFeatureToggleList()
  const selectedPremiumFleets = useSelectedPremiumFleets()

  const fbtFeatureToggle = featureToggleList.includes('FBT')

  if (!fbtFeatureToggle) {
    return (
      <Layout>
        <Page404 withoutNav />
      </Layout>
    )
  }

  // no FBT reporting for currently selected fleet(s) - show register interest form without side nav
  const hasFbtFleetSelected = selectedPremiumFleets.length > 0

  return (
    <Layout accordionNavigation={hasFbtFleetSelected ? navigation : undefined}>
      <Routes>
        <Route path="summary" element={<FbtSummaryRoutes />} />
        <Route path="submissions/*" element={<FbtSubmissionsRoutes />} />
        <Route path="" element={<FbtSubmissionsRoutes />} />
      </Routes>
    </Layout>
  )
}

export default FBTRoutes
